import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace OperateLog {
    /**
    * 日志列表
    */
    export var GetOperateLogList = (query: any): Promise<any> => {
        return Get(`/msls/OperateLog/getOperateLogList?${qs.stringify(query)}`, {});
    };
}

